/**
 * Configuration centralisée pour l'API
 * Toutes les URLs et paramètres liés à l'API sont définis ici
 */

// URL de base de l'API - à configurer selon l'environnement
// export const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000';
export const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://fan-club-challenge.zen-apps.com/api';

// URL pour accéder aux médias du serveur
export const MEDIA_URL = `${API_BASE_URL}/public`;

// Endpoints spécifiques
export const API_ENDPOINTS = {
  AUTH: {
    REQUEST_TOKEN: `${API_BASE_URL}/auth/request-token`,
    VERIFY: `${API_BASE_URL}/auth/verify`,
    DIRECT: `${API_BASE_URL}/auth/direct`
  },
  UNIVERSITIES: {
    ACTIVE_VENUE: `${API_BASE_URL}/active-venue/universities`,
    RANKING: `${API_BASE_URL}/active-venue/universities/ranking`
  },
  SUPPORTERS: {
    SUPPORT: `${API_BASE_URL}/supporters/support`
  },
  EDITIONS: {
    ACTIVE_INFO: `${API_BASE_URL}/editions/active/info`
  },
  // Vous pourrez ajouter d'autres endpoints ici au fur et à mesure
};

// Timeout par défaut pour les requêtes (en ms)
export const DEFAULT_API_TIMEOUT = 30000;

// En-têtes par défaut pour les requêtes
export const DEFAULT_HEADERS = {
  'Content-Type': 'application/json',
};

/**
 * Fonction pour ajouter le token d'authentification aux en-têtes
 * @param headers En-têtes existants (optionnel)
 * @returns En-têtes avec le token d'authentification
 */
export const getAuthHeaders = (headers: Record<string, string> = {}): Record<string, string> => {
  const token = localStorage.getItem('auth_token');
  
  if (token) {
    return {
      ...DEFAULT_HEADERS,
      ...headers,
      'Authorization': `Bearer ${token}`
    };
  }
  
  return {
    ...DEFAULT_HEADERS,
    ...headers
  };
};

/**
 * Fonction pour générer l'URL complète d'un média
 * @param path Chemin relatif du média (sans le /public)
 * @returns URL complète du média
 */
export const getMediaUrl = (path: string): string => {
  // Si le chemin est déjà une URL complète (commence par http ou https), on la retourne telle quelle
  if (path.startsWith('http://') || path.startsWith('https://')) {
    return path;
  }
  
  // Si le chemin commence par un slash, on le retire pour éviter les doubles slashes
  const cleanPath = path.startsWith('/') ? path.substring(1) : path;
  
  // On retourne l'URL complète
  return `${MEDIA_URL}/${cleanPath}`;
};
